// Flattens a Rails ErrorSerializer payload ({ errors: { field: [messages] } })
// into a single display string; falls back when no server messages are present.
export default function serverErrorMessage(err, fallback) {
  const errors = err.response && err.response.data && err.response.data.errors;
  if (errors) {
    const messages = [];
    Object.keys(errors).forEach(key => {
      [].concat(errors[key]).forEach(message => messages.push(message));
    });
    if (messages.length) return messages.join('. ');
  }
  return fallback;
}
